module.exports = __webpack_public_path__ + "img/IMG-20200419-WA0004.183ecd35.jpg";